// extracted by mini-css-extract-plugin
module.exports = {"BasicLabel":"BasicLabel_BasicLabel__7eaZc","Checked":"BasicLabel_Checked__J21d_","FontLabelInner":"BasicLabel_FontLabelInner__n5jnp"};